"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.inputValidation = void 0;
function checkName(e) {
    if (e.key.match(/[a-zA-Z1-9]/)) {
        const usernameAfterHTML = document.getElementById('name-alert');
        const username = document.getElementById('name').value;
        if (username.charAt(0).match(/[a-z]/)) {
            usernameAfterHTML.innerHTML = 'name must start with Uppercase character';
        }
        else if (username.match(/^[a-zA-Z]+$/)) {
            usernameAfterHTML.innerText = '';
            if (username.split('').length < 4) {
                usernameAfterHTML.innerHTML = 'name must be more than 3 characters';
            }
        }
        else {
            usernameAfterHTML.innerText = 'only latin letter accepted';
            if (username.split('').length < 4) {
                usernameAfterHTML.innerHTML += ', name must be more than 3 characters';
            }
        }
    }
}
function checkSurname(e) {
    if (e.key.match(/[a-zA-Z1-9]/)) {
        const surnameAfterHTML = document.getElementById('surname-alert');
        const surname = document.getElementById('surname').value;
        if (surname.charAt(0).match(/[a-z]/)) {
            surnameAfterHTML.innerHTML = 'surname must start with Uppercase character';
        }
        else if (surname.match(/^[a-zA-Z]+$/)) {
            surnameAfterHTML.innerText = '';
            if (surname.split('').length < 3) {
                surnameAfterHTML.innerHTML = 'surname must be more than 2 characters';
            }
        }
        else {
            surnameAfterHTML.innerText = 'only latin letter accepted';
            if (surname.split('').length < 3) {
                surnameAfterHTML.innerHTML += ', surname must be more than 2 characters';
            }
        }
    }
}
function inputValidation() {
    const inputs = document.querySelectorAll('.input-field');
    inputs.forEach((input) => {
        switch (input.name) {
            case 'name':
                input.addEventListener('keyup', checkName);
                break;
            default:
                input.addEventListener('keyup', checkSurname);
                break;
        }
    });
}
exports.inputValidation = inputValidation;
